import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from './index';
export function InfoSkeleton({ labelWidth = 50, contentWidth = 200, showLabel = true, }) {
    return (_jsxs("div", { className: "flex flex-col gap-1", children: [showLabel && (_jsx(Skeleton, { width: labelWidth, height: 16, borderRadius: 6 })), _jsx(Skeleton, { width: contentWidth, height: 16, borderRadius: 6 })] }));
}
